import axios from 'axios';

/** API requests must use `VITE_API_BASE_URL`, not the frontend dev-server origin. */
const instance = axios.create({
  baseURL: (import.meta.env.VITE_API_BASE_URL as string | undefined)?.replace(/\/$/, '') ?? '',
});

export default instance;
